export const isValidPassword = (password: string): boolean => {
  const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
  return regex.test(password);
};

export const passwordRequirementsMessage = `
A senha deve conter no mínimo 8 caracteres, com 1 letra minúscula, 1 letra maiúscula, 1 número e 1 caractere especial.
`;
